import {
  LoaderSpin,
  type LoaderSpinProps,
} from '@framework/ui/components/loader/LoaderSpin.tsx';
import { LoadingPageBody } from '@framework/ui/components/loader/LoadingPageBody.tsx';
import { PageLayout } from '../../ui/layout/PageLayout.tsx';

export interface LoadingPageProps extends LoaderSpinProps {
  /** noLayout: se True, non viene visualizzato l'header della pagina.
   * Da utilizzare se il componente non è utilizzato in una pagina ma in una Tab.
   *
   * Default: false
   */
  noLayout?: boolean;
}

/**
 * Pagina di caricamento generica.
 */
export function LoadingPage(props: LoadingPageProps) {
  const { noLayout, ...rest } = props;
  if (noLayout) {
    return <LoaderSpin transparent full />;
  }
  return (
    <PageLayout hasTopBar={!noLayout}>
      <LoadingPageBody {...rest} />
    </PageLayout>
  );
}
